import { Refresh } from '@mui/icons-material';
import { keyframes, styled, Typography } from '@mui/material';
import { Button } from 'components/mui/common/Button';
import { getFontColor } from 'utils/getFontColor';

export const LoadMoreButton = styled(Button)(({ theme }) => ({
  minWidth: 220,
  borderRadius: 24,
  padding: '8px 32px',
  fontWeight: 600,
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: theme.shadows[2],
  },
}));

export const TableHeaderWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  '& .MuiButton-outlined': {
    borderRadius: '8px',
    borderColor: theme.palette.grey[300],
    color: theme.palette.text.secondary,
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    padding: '4px 12px',
    minHeight: '32px',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: isMobile ? 'row' : 'column',
    alignItems: isMobile ? 'center' : 'flex-end',
    margin: 0,
    gap: '6px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    gap: '4px',
    '& .MuiButton-root': {
      padding: '0 8px',
      fontSize: '0.75rem',
    },
    '& .MuiButton-startIcon': {
      marginRight: '4px',
    },
  },
}));

// TableCardWrapper, TableSkeleton, SkeletonRow, SkeletonCell are now in components/common/Table/Table.styles

export const SpinningRefresh = styled(Refresh, {
  shouldForwardProp: (prop) => prop !== 'spinning',
})<{ spinning?: boolean }>(({ spinning }) => ({
  animation: spinning
    ? `${keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `} 0.8s linear infinite`
    : 'none',
}));

export { headerIconButtonStyles } from 'components/common/Table/Table.styles';

export const ColoredHeader = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'mb',
})<{ backgroundColor?: string; mb?: number | string }>(({ theme, backgroundColor, mb }) => ({
  fontSize: '15px',
  fontWeight: 600,
  width: '100%',
  padding: '12px 16px',
  marginBottom: '12px',
  ...(backgroundColor
    ? {
        backgroundColor,
        color: getFontColor(backgroundColor),
        borderRadius: '8px',
      }
    : {
        paddingLeft: 0,
        paddingRight: 0,
        color: theme.palette.text.primary,
      }),
  ...(mb !== undefined ? { marginBottom: mb } : {}),
}));
